<template>
    <UInput
        ref="discountInput"
        :value="modelValue * 100"
        type="number"
        size="sm"
        placeholder="%"
        autocomplete="off"
        :ui="{
            base: 'spinnerless',
        }"
        data-cy="discount-percent-input"
        @input="handleDiscountInputEvent"
        @focusin="selectInput"
    >
        <template #trailing>
            <span class="text-muted">%</span>
        </template>
    </UInput>
</template>

<script setup lang="ts">

import {selectInput} from '@/input-utils/inputUtils'

defineProps({
    modelValue: {
        type: Number,
        required: true
    }
})

const emit = defineEmits(['update:modelValue'])

const handleDiscountInputEvent = (event: Event) => {
    const target = event.target as HTMLInputElement
    emit('update:modelValue', Number(target.value) / 100)
}

</script>

<style scoped>

</style>